/* NISEO Skin — public prelaunch behavior and success-state handling. */
(function () {
  'use strict';

  function decodeEntities(value) {
    var decoder = document.createElement('textarea');
    decoder.innerHTML = String(value || '');
    return decoder.value;
  }

  function closeMobileMenu() {
    var menu = document.getElementById('NiseoMobileMenu');
    if (!menu || !menu.classList.contains('is-open')) return;
    /* Route through the central overlay manager (niseo.js) so its
       activeOverlay / focus-trap state is cleared correctly. */
    var closeButton = menu.querySelector('[data-menu-close]');
    if (closeButton) { closeButton.click(); return; }
    /* Fallback only if no close control is rendered. */
    menu.classList.remove('is-open');
    menu.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    document.querySelectorAll('[aria-controls="NiseoMobileMenu"]').forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    });
  }

  function bindPrelaunchNavigation() {
    var menu = document.getElementById('NiseoMobileMenu');
    if (!menu) return;
    menu.addEventListener('click', function (event) {
      var link = event.target.closest('a[href]');
      if (!link) return;
      closeMobileMenu();
    });
  }

  function showWaitlistSuccess() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('waitlist') !== 'success') return;

    var drawer = document.getElementById('NiseoWaitlistDrawer');
    if (!drawer) return;

    var body = drawer.querySelector('.niseo-waitlist-body');
    if (!body) return;

    var title = drawer.getAttribute('data-success-title') || "You're on the list.";
    var message = drawer.getAttribute('data-success-body') || "We'll write when it's ready.";
    var back = drawer.getAttribute('data-success-back') || 'Back to the store';

    var success = document.createElement('div');
    success.className = 'niseo-waitlist-success';
    success.setAttribute('role', 'status');
    success.setAttribute('aria-live', 'polite');

    var heading = document.createElement('h2');
    heading.textContent = decodeEntities(title);

    var copy = document.createElement('p');
    copy.textContent = decodeEntities(message);

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'niseo-btn niseo-btn--dark niseo-btn--md';
    button.setAttribute('data-drawer-close', '');
    button.setAttribute('data-overlay-initial-focus', '');
    button.style.alignSelf = 'flex-start';
    button.textContent = decodeEntities(back);

    success.appendChild(heading);
    success.appendChild(copy);
    success.appendChild(button);
    body.textContent = '';
    body.appendChild(success);

    var trigger = document.querySelector('[data-open-waitlist]');
    if (trigger) {
      trigger.click();
    } else {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var initial = drawer.querySelector('[data-overlay-initial-focus]');
      if (initial) initial.focus();
    }

    var cleanUrl = window.location.pathname + window.location.hash;
    window.history.replaceState({}, document.title, cleanUrl);
  }

  function init() {
    bindPrelaunchNavigation();
    showWaitlistSuccess();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
